import type {UseMutationResult} from 'react-query';
import {useMutation, useQueryClient} from 'react-query';
import {apiUrl} from '@/utils/api';
import {type ChangeRequest} from '@/types/ChangeRequest';

type Props = {
    jwt : string;
    courseNumber : string;
    sectionId : string;
    request : string;
};

type UpdateChangeRequestResponse = {
    data: ChangeRequest;
    errorCode: number;
    message: string;
};

export const useUpdateChangeRequest = () : UseMutationResult<UpdateChangeRequestResponse, unknown, Props> => {
    const queryClient = useQueryClient();

    return useMutation(async ({jwt, courseNumber, sectionId, request} : Props) => {
        const response = await fetch(apiUrl(`/v1/change-request/put`).toString(), {
            method: 'PUT',
            body: JSON.stringify({
                courseNumber: courseNumber,
                sectionId: sectionId,
                request: request,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`,
            },
        });

        if (!response.ok) {
            throw new Error('Unable to update change request.');
        }

        return (await response.json() as UpdateChangeRequestResponse);
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([`change-requests`]);
        },
    });
};
